import TtamAudienceSizeFlexMainTitle from './main-title/index.vue';
import TtamAudienceSizeFlexEstimateChart from './estimate-chart/index.vue';
import TtamAudienceSizeFlexEstimateNum from './estimate-num/index.vue';
import TtamAudienceSizeFlexEstimateTip from './estimate-tip/index.vue';

export default {
  TtamAudienceSizeFlexMainTitle,
  TtamAudienceSizeFlexEstimateChart,
  TtamAudienceSizeFlexEstimateNum,
  TtamAudienceSizeFlexEstimateTip,
};
